// Calendar-day helpers for pay-link installment plans. Dates are 'YYYY-MM-DD'
// strings in the Los Angeles calendar (KBT's timezone), never JS Date objects,
// so the browser's own timezone can't shift a payment day.
const dayFormat = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Los_Angeles',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const laToday = (now = new Date()) => dayFormat.format(now);

export const addDays = (ymd, days) => {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
};

export const laTodayPlus = (days) => addDays(laToday(), days);

export const longDateYmd = (ymd) => {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const ordinalDay = (ymd) => {
  const day = Number(ymd.split('-')[2]);
  const mod100 = day % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${day}th`;
  return `${day}${{ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th'}`;
};
